class t extends Error {
  componentName;
  constructor(r, o) {
    super(`<${r}> ${o}`), this.componentName = r;
  }
}
export {
  t as ComponentSetupError
};
//# sourceMappingURL=component-setup-error.js.map
